import Vue from "vue";
import Vuex from "vuex";
import { UserState } from "./user";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    snackbar: {
      text: "",
      color: "",
      show: false
    }
  },
  getters: {
    snackbar: state => state.snackbar
  },
  mutations: {
    updateSnackbar(state, out) {
      state.snackbar = out;
    }
  },
  modules: {
    user: UserState
  }
});
